/** Normalize availability/settings docs from Firestore (nested or legacy flat fields). */

export const DEFAULT_GENERAL_SETTINGS = {
  advanceBookingDays: 365,
  blockDaysBeforeBooking: 2,
  preTimeBuffer: 1,
  postTimeBuffer: 1,
};

export const DEFAULT_WEEKLY_SCHEDULE = {
  monday: { start: '6:00 AM', end: '10:00 PM', enabled: true },
  tuesday: { start: '6:00 AM', end: '10:00 PM', enabled: true },
  wednesday: { start: '6:00 AM', end: '10:00 PM', enabled: true },
  thursday: { start: '6:00 AM', end: '10:00 PM', enabled: true },
  friday: { start: '6:00 AM', end: '10:00 PM', enabled: true },
  saturday: { start: '6:00 AM', end: '10:00 PM', enabled: true },
  sunday: { start: '6:00 AM', end: '10:00 PM', enabled: true },
};

function toNumber(value, fallback) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function normalizeGeneralSettings(source = {}) {
  const nested = source.generalSettings || {};
  const legacyBlockDays =
    nested.blockDaysBeforeBooking ??
    nested.blockHoursBeforeBooking ??
    source.blockDaysBeforeBooking ??
    source.blockHoursBeforeBooking;

  return {
    advanceBookingDays: toNumber(
      nested.advanceBookingDays ?? source.advanceBookingDays,
      DEFAULT_GENERAL_SETTINGS.advanceBookingDays
    ),
    blockDaysBeforeBooking: toNumber(
      legacyBlockDays,
      DEFAULT_GENERAL_SETTINGS.blockDaysBeforeBooking
    ),
    preTimeBuffer: toNumber(
      nested.preTimeBuffer ?? source.preTimeBuffer,
      DEFAULT_GENERAL_SETTINGS.preTimeBuffer
    ),
    postTimeBuffer: toNumber(
      nested.postTimeBuffer ?? source.postTimeBuffer,
      DEFAULT_GENERAL_SETTINGS.postTimeBuffer
    ),
  };
}

export function normalizeAvailabilityRecord(source = {}) {
  return {
    weeklySchedule: source.weeklySchedule || DEFAULT_WEEKLY_SCHEDULE,
    generalSettings: normalizeGeneralSettings(source),
  };
}
